/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const FSS_LOCALSTORAGE_PREFIX = 'fss_'
export const DEPLOY_ALL_IN_ONE_REGION_SELECTED = 'deployAllInOneRegionSelected'
export const DEPLOY_SCANNER_REGION_SELECTED = 'deployScannerRegionSelected'
export const DEPLOY_STORAGE_REGION_SELECTED = 'deployStorageRegionSelected'
export const IS_ONE_PAGE_VIEWED = 'isOnePageViewed'
export const LAST_TIME_DISPLAY_BAR_CHART_GUIDE = 'lastTimeDisplyBarChartGuide'
export const ACTIVE_PROVIDER = 'activeProvider'
export const HAS_DISPLAYED_GCP_DM_DEPRECATED_ANNOUNCEMENT_MODAL =
  'hasDisplayedGCPDeployManagerDeprecatedAnnouncemetModal'

export type FSSStorageKeyType =
  | typeof DEPLOY_ALL_IN_ONE_REGION_SELECTED
  | typeof DEPLOY_SCANNER_REGION_SELECTED
  | typeof DEPLOY_STORAGE_REGION_SELECTED
  | typeof IS_ONE_PAGE_VIEWED
  | typeof LAST_TIME_DISPLAY_BAR_CHART_GUIDE
  | typeof ACTIVE_PROVIDER
  | typeof HAS_DISPLAYED_GCP_DM_DEPRECATED_ANNOUNCEMENT_MODAL
